(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function cleanBaseUrl() {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.set('view', 'oos-feed');
    return url;
  }

  function currentPage() {
    var url = new URL(window.location.href);
    var p = parseInt(url.searchParams.get('page') || '1', 10);
    return isNaN(p) || p < 1 ? 1 : p;
  }

  function pageUrl(page) {
    var url = new URL(window.location.href);
    url.searchParams.delete('view');
    if (page <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(page));
    }
    return url.pathname + (url.search ? url.search : '');
  }

  async function fetchFeedPage(page) {
    var url = cleanBaseUrl();
    url.searchParams.set('page', String(page));

    var res = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!res.ok) {
      throw new Error('Unable to load collection products.');
    }

    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var feed = qs('#st-oos-feed', doc);

    if (!feed) {
      throw new Error('Collection feed is unavailable.');
    }

    return {
      totalPages: parseInt(feed.getAttribute('data-total-pages') || '1', 10),
      items: qsa('.st-oos-feed-item', feed).map(function (node) {
        return {
          available: node.getAttribute('data-available') === '1',
          vendor: node.getAttribute('data-vendor') || '',
          html: node.innerHTML
        };
      })
    };
  }

  function renderPagination(container, totalPages, activePage) {
    container.innerHTML = '';
    if (totalPages <= 1) return;

    var nav = document.createElement('div');
    nav.className = 'pagination st-global-pagination';

    function addLink(label, page, active, ariaLabel) {
      if (active) {
        var span = document.createElement('span');
        span.className = 'page current';
        span.textContent = label;
        nav.appendChild(span);
        return;
      }

      var a = document.createElement('a');
      a.href = pageUrl(page);
      a.textContent = label;
      if (ariaLabel) a.setAttribute('aria-label', ariaLabel);
      nav.appendChild(a);
    }

    if (activePage > 1) addLink('←', activePage - 1, false, 'Previous page');

    var windowSize = 2;
    var pages = [];
    pages.push(1);

    for (var p = Math.max(2, activePage - windowSize); p <= Math.min(totalPages - 1, activePage + windowSize); p++) {
      pages.push(p);
    }

    if (totalPages > 1) pages.push(totalPages);

    var last = 0;
    pages.forEach(function (p) {
      if (p - last > 1) {
        var dots = document.createElement('span');
        dots.className = 'deco';
        dots.textContent = '…';
        nav.appendChild(dots);
      }
      addLink(String(p), p, p === activePage);
      last = p;
    });

    if (activePage < totalPages) addLink('→', activePage + 1, false, 'Next page');

    container.appendChild(nav);
  }


  function normalizedVendor(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, 'and')
      .replace(/[^a-zA-Z0-9]/g, '')
      .toLowerCase();
  }

  function vendorMatches(productVendor, requestedVendor) {
    var p = normalizedVendor(productVendor);
    var r = normalizedVendor(requestedVendor);
    if (!r) return true;
    if (p === r) return true;

    /* Common label/vendor aliases used on STYLISHTOP. */
    var aliases = {
      "dior": ["dior", "christiandior"],
      "christiandior": ["dior", "christiandior"],
      "hermes": ["hermes"],
      "bvlgari": ["bvlgari", "bulgari"],
      "bulgari": ["bvlgari", "bulgari"],
      "ysl": ["ysl", "saintlaurent", "yvesaintlaurent"],
      "saintlaurent": ["ysl", "saintlaurent", "yvesaintlaurent"],
      "vancleefandarpels": ["vancleefandarpels", "vancleefarpels"]
    };

    var candidates = aliases[r] || [r];
    return candidates.indexOf(p) !== -1;
  }

  function requestedVendor() {
    var url = new URL(window.location.href);
    return url.searchParams.get('st_vendor') || '';
  }

  function preserveVendorInForms() {
    var vendor = requestedVendor();
    if (!vendor) return;

    ['#st-native-filter-form', '.st-native-sort'].forEach(function (selector) {
      var form = qs(selector);
      if (!form || qs('input[name="st_vendor"]', form)) return;
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'st_vendor';
      hidden.value = vendor;
      form.appendChild(hidden);
    });
  }

  async function init() {
    var productGrid = qs('#st-global-oos-products');
    var pager = qs('#st-global-oos-pagination');
    if (!productGrid || !pager) return;

    preserveVendorInForms();

    var perPage = parseInt(productGrid.getAttribute('data-products-per-page') || '12', 10);
    if (!perPage || perPage < 1) perPage = 12;

    productGrid.classList.add('st-global-oos-loading');

    try {
      var first = await fetchFeedPage(1);
      var all = first.items.slice();

      if (first.totalPages > 1) {
        var requests = [];
        for (var page = 2; page <= first.totalPages; page++) {
          requests.push(fetchFeedPage(page));
        }

        var remaining = await Promise.all(requests);
        remaining.forEach(function (result) {
          all = all.concat(result.items);
        });
      }

      /* Featured Designer menu uses st_vendor, independent of Shopify's exact vendor casing. */
      var menuVendor = requestedVendor();
      if (menuVendor) {
        all = all.filter(function (item) {
          return vendorMatches(item.vendor, menuVendor);
        });
      }

      /* Stable partition: preserve the current Shopify sort order inside each group. */
      var inStock = [];
      var outOfStock = [];

      all.forEach(function (item) {
        (item.available ? inStock : outOfStock).push(item);
      });

      var globallySorted = inStock.concat(outOfStock);
      var totalClientPages = Math.max(1, Math.ceil(globallySorted.length / perPage));
      var activePage = Math.min(currentPage(), totalClientPages);
      var start = (activePage - 1) * perPage;
      var slice = globallySorted.slice(start, start + perPage);

      productGrid.innerHTML = slice.map(function (item) {
        return item.html;
      }).join('');

      renderPagination(pager, totalClientPages, activePage);

      var serverPagination = qs('.st-server-pagination');
      if (serverPagination) serverPagination.style.display = 'none';
    } catch (err) {
      console.error('[STYLISHTOP] Global OOS sorting fallback:', err);
      /* Leave the normal server-rendered page untouched if anything fails. */
      pager.innerHTML = '';
    } finally {
      productGrid.classList.remove('st-global-oos-loading');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();